/**
 * Half Flush (every suited tile in one suit, at least one honor present) and
 * Full Flush (every tile in one suit, zero honors) — mutually exclusive by
 * definition, so one detector returns at most one of the two, `fullFlush`
 * taking priority. Pure tile-kind scan; no decomposition needed.
 */

import type { Suit, Tile } from '../../game/types.js';
import type { MatchedPattern, ScoringContext } from '../types.js';

const HALF_FLUSH_VALUE = 1;
const FULL_FLUSH_VALUE = 3;

function allHandTiles(context: ScoringContext): Tile[] {
  return [...context.concealedTiles, ...context.melds.flatMap((meldEntry) => meldEntry.tiles), context.winningTile];
}

export function matchFlush(context: ScoringContext): MatchedPattern | null {
  const tiles = allHandTiles(context);
  const suits = new Set<Suit>(tiles.filter((tile) => tile.kind === 'suit').map((tile) => tile.suit));
  const hasHonor = tiles.some((tile) => tile.kind === 'honor');

  if (suits.size !== 1) return null;
  if (!hasHonor) return { name: 'fullFlush', kind: 'double', value: FULL_FLUSH_VALUE };
  return { name: 'halfFlush', kind: 'double', value: HALF_FLUSH_VALUE };
}
